import {
  Box,
  Button,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  formatCurrency,
  formatList,
} from 'renderer/shared/formatters/formatters';
import { Link } from 'react-router-dom';
import { DownloadOutlined } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ExportPDFView from 'renderer/features/users-page/components/export-pdf';
import { transformTransactionToInvoice } from 'renderer/features/payments-page/schemas/transaction.transformer';
import { TransactionDetails } from 'renderer/features/payments-page/schemas/transaction.schemas';
import { PurchaseConfirmation } from '../schemas/purchase.schemas';

const tableStyles = {
  tableContainer: {
    // marginTop: '20px',
    marginBottom: '20px',
    border: '1px solid rgba(224, 224, 224, 1)',
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: '#f5f5f5',
  },
  tableCell: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  tableRow: {
    '&:last-child td': {
      border: 0,
    },
  },
};

const PDFIconButton = ({
  transaction,
  customerName,
}: {
  transaction: TransactionDetails;
  customerName: string;
}) => {
  const theme = useTheme();
  const transactionInfo = transformTransactionToInvoice(transaction);
  return (
    <PDFDownloadLink
      document={<ExportPDFView transaction={transactionInfo} />}
      fileName={`${transaction._id}.pdf`}
    >
      <Tooltip title="Download" placement="top">
        <IconButton>
          <DownloadOutlined style={{ color: theme.palette.grey[900] }} />
        </IconButton>
      </Tooltip>
    </PDFDownloadLink>
  );
};

// const PurchaseConfirmationPage = ({
//   productName,
//   prices,
//   to,
//   serialNumbers,
//   transactions,
//   customerName,
// }: PurchaseConfirmation) => {
//   console.log('PurchaseConfirmationPage', {
//     productName,
//     prices,
//     to,
//     serialNumbers,
//     transactions,
//     customerName,
//   });
//   return (
//     <Container maxWidth="sm">
//       <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
//         <Typography variant="h4" gutterBottom>
//           Thank you for your purchase!
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           A confirmation email has been sent to {to}. Please save this for your
//           records. If you created an account, your serial numbers and invoices
//           are also available to you in your Account Dashboard.
//         </Typography>
//         <List>
//           <ListItem>
//             <ListItemText primary="Product Name" secondary={productName} />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Serial Number(s)"
//               secondary={formatList(serialNumbers ?? [])}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Product Price"
//               secondary={formatCurrency(prices.startingPrice)}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary="Copies" secondary={prices.copies} />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Subtotal"
//               secondary={formatCurrency(prices.subtotal)}
//             />
//           </ListItem>
//           {prices.discountDetails && (
//             <ListItem>
//               <ListItemText
//                 primary="Discount"
//                 secondary={formatCurrency(prices.discountDetails.amount)}
//               />
//             </ListItem>
//           )}
//           <ListItem>
//             <ListItemText
//               primary="Total"
//               secondary={formatCurrency(prices.totalPrice)}
//             />
//           </ListItem>
//         </List>{' '}
//         {/*
//         <Typography variant="h6" gutterBottom>
//           Invoice Download
//         </Typography>
//         <TableContainer component={Paper} sx={tableStyles.tableContainer}>
//           <Table size="small">
//             <TableBody>
//               {transactions.map((payment) => (
//                 <TableRow
//                   key={payment._id}
//                   sx={{
//                     '&:last-child td': {
//                       border: 0,
//                     },
//                   }}
//                 >
//                   <TableCell>{`${payment._id.toString()}.pdf`}</TableCell>
//                   <TableCell align="center">
//                     <PDFIconButton
//                       transaction={{ ...payment }}
//                       customerName={customerName}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer> */}
//         <Box mt={4}>
//           <Link to="/">
//             <Button variant="contained" color="primary" sx={{ mr: 1 }}>
//               Go to Store
//             </Button>
//           </Link>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// const PurchaseConfirmationPage = ({
//   productName,
//   prices,
//   to,
//   serialNumbers,
//   transactions,
//   customerName,
// }: PurchaseConfirmation) => {
//   const fallback = transactions?.[0]; // fallback source of data

//   const displayName =
//     customerName ??
//     `${fallback?.firstName ?? ''} ${fallback?.lastName ?? ''}`.trim();
//   const displayTo = to ?? fallback?.email;
//   const displayProductName = productName ?? fallback?.productName;
//   const displayPrices = prices ?? fallback?.prices;
//   const displaySerials = serialNumbers ?? fallback?.serials;

//   console.log('🧾 PurchaseConfirmationPage', {
//     productName: displayProductName,
//     prices: displayPrices,
//     to: displayTo,
//     serialNumbers: displaySerials,
//     transactions,
//     customerName: displayName,
//   });

//   return (
//     <Container maxWidth="sm">
//       <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
//         <Typography variant="h4" gutterBottom>
//           Thank you for your purchase!
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           A confirmation email has been sent to {displayTo}. Please save this
//           for your records. If you created an account, your serial numbers and
//           invoices are also available to you in your Account Dashboard.
//         </Typography>
//         <List>
//           <ListItem>
//             <ListItemText
//               primary="Product Name"
//               secondary={displayProductName}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Serial Number(s)"
//               secondary={formatList(displaySerials ?? [])}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Product Price"
//               secondary={formatCurrency(displayPrices?.startingPrice)}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary="Copies" secondary={displayPrices?.copies} />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary="Subtotal"
//               secondary={formatCurrency(displayPrices?.subtotal)}
//             />
//           </ListItem>
//           {displayPrices?.discountDetails && (
//             <ListItem>
//               <ListItemText
//                 primary="Discount"
//                 secondary={formatCurrency(displayPrices.discountDetails.amount)}
//               />
//             </ListItem>
//           )}
//           <ListItem>
//             <ListItemText
//               primary="Total"
//               secondary={formatCurrency(displayPrices?.totalPrice)}
//             />
//           </ListItem>
//         </List>

//         <Box mt={4}>
//           <Link to="/">
//             <Button variant="contained" color="primary" sx={{ mr: 1 }}>
//               Go to Store
//             </Button>
//           </Link>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// const PurchaseConfirmationPage = ({
//   productName,
//   prices,
//   to,
//   serialNumbers,
//   transactions,
//   customerName,
// }: PurchaseConfirmation) => {
//   const hasMultiple = Array.isArray(transactions) && transactions.length > 1;
//   const fallback = transactions?.[0];

//   const displayName =
//     customerName ??
//     `${fallback?.firstName ?? ''} ${fallback?.lastName ?? ''}`.trim();
//   const displayTo = to ?? fallback?.email;

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
//         <Typography variant="h4" gutterBottom>
//           Thank you for your purchase!
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           A confirmation email has been sent to {displayTo}. Please save this
//           for your records. If you created an account, your serial numbers and
//           invoices are also available to you in your Account Dashboard.
//         </Typography>

//         {(transactions ?? []).map((txn, i) => (
//           <Paper
//             key={txn._id}
//             variant="outlined"
//             sx={{ p: 3, mt: 4, textAlign: 'left' }}
//           >
//             {hasMultiple && (
//               <Typography variant="h6" sx={{ mb: 2 }}>
//                 Product {i + 1}
//               </Typography>
//             )}
//             <List dense>
//               <ListItem>
//                 <ListItemText
//                   primary="Product Name"
//                   secondary={txn.productName ?? productName}
//                 />
//               </ListItem>
//               <ListItem>
//                 <ListItemText
//                   primary="Serial Number(s)"
//                   secondary={formatList(txn.serials ?? serialNumbers ?? [])}
//                 />
//               </ListItem>
//               <ListItem>
//                 <ListItemText
//                   primary="Product Price"
//                   secondary={formatCurrency(
//                     txn.prices?.startingPrice ?? prices?.startingPrice,
//                   )}
//                 />
//               </ListItem>
//               <ListItem>
//                 <ListItemText
//                   primary="Copies"
//                   secondary={txn.prices?.copies ?? prices?.copies}
//                 />
//               </ListItem>
//               <ListItem>
//                 <ListItemText
//                   primary="Subtotal"
//                   secondary={formatCurrency(
//                     txn.prices?.subtotal ?? prices?.subtotal,
//                   )}
//                 />
//               </ListItem>
//               {txn.prices?.discountDetails && (
//                 <ListItem>
//                   <ListItemText
//                     primary="Discount"
//                     secondary={formatCurrency(
//                       txn.prices.discountDetails.amount,
//                     )}
//                   />
//                 </ListItem>
//               )}
//               <ListItem>
//                 <ListItemText
//                   primary="Total"
//                   secondary={formatCurrency(
//                     txn.prices?.totalPrice ?? prices?.totalPrice,
//                   )}
//                 />
//               </ListItem>
//               <ListItem>
//                 <Box display="flex" alignItems="center" gap={1}>
//                   <Typography>Invoice:</Typography>
//                   <PDFIconButton transaction={txn} customerName={displayName} />
//                 </Box>
//               </ListItem>
//             </List>
//           </Paper>
//         ))}

//         <Box mt={4}>
//           <Link to="/">
//             <Button variant="contained" color="primary">
//               Go to Store
//             </Button>
//           </Link>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// const PurchaseConfirmationPage = ({
//   productName,
//   prices,
//   to,
//   serialNumbers,
//   transactions,
//   customerName,
// }: PurchaseConfirmation) => {
//   const fallback = transactions?.[0];

//   const displayName =
//     customerName ??
//     `${fallback?.firstName ?? ''} ${fallback?.lastName ?? ''}`.trim();
//   const displayTo = to ?? fallback?.email;

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
//         <Typography variant="h4" gutterBottom>
//           Thank you for your purchase!
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           A confirmation email has been sent to {displayTo}. Please save this
//           for your records. If you created an account, your serial numbers and
//           invoices are also available to you in your Account Dashboard.
//         </Typography>

//         {/* <TableContainer component={Paper} sx={{ mt: 4 }}> */}
//         <TableContainer sx={{ mt: 4 }}>
//           <Table size="small">
//             <TableBody>
//               {(transactions ?? []).map((txn) => (
//                 <TableRow key={txn._id}>
//                   <TableCell sx={{ borderBottom: 'none' }}>
//                     <Typography variant="body1" fontWeight="bold">
//                       {txn.productName ?? productName}
//                     </Typography>
//                     <Typography variant="body2" color="textSecondary">
//                       Serials: {formatList(txn.serials ?? serialNumbers ?? [])}
//                     </Typography>
//                   </TableCell>
//                   <TableCell
//                     align="right"
//                     sx={{ whiteSpace: 'nowrap', borderBottom: 'none' }}
//                   >
//                     {formatCurrency(
//                       txn.prices?.totalPrice ?? prices?.totalPrice,
//                     )}
//                   </TableCell>
//                   <TableCell align="center" sx={{ borderBottom: 'none' }}>
//                     <PDFIconButton
//                       transaction={txn}
//                       customerName={displayName}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box mt={4}>
//           <Link to="/">
//             <Button variant="contained" color="primary">
//               Go to Store
//             </Button>
//           </Link>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// const PurchaseConfirmationPage = ({
//   productName,
//   prices,
//   to,
//   serialNumbers,
//   transactions,
//   customerName,
// }: PurchaseConfirmation) => {
//   const fallback = transactions?.[0];

//   const displayName =
//     customerName ??
//     `${fallback?.firstName ?? ''} ${fallback?.lastName ?? ''}`.trim();
//   const displayTo = to ?? fallback?.email;

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
//         <Typography variant="h4" gutterBottom>
//           Thank you for your purchase!
//         </Typography>
//         <Typography variant="subtitle1" gutterBottom>
//           A confirmation email has been sent to {displayTo}. Please save this
//           for your records. If you created an account, your serial numbers and
//           invoices are also available to you in your Account Dashboard.
//         </Typography>

//         <TableContainer sx={{ mt: 4 }}>
//           <Table size="small">
//             <TableBody>
//               {(transactions ?? []).map((txn) => {
//                 const serials = txn.serials ?? serialNumbers ?? [];
//                 const copies = txn.prices?.copies ?? prices?.copies;
//                 const totalPrice = txn.prices?.totalPrice ?? prices?.totalPrice;

//                 return (
//                   <TableRow key={txn._id}>
//                     <TableCell sx={{ borderBottom: 'none' }}>
//                       <Typography variant="body1" fontWeight="bold">
//                         {txn.productName ?? productName}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Serials: {formatList(serials)} &nbsp;&bull;&nbsp;
//                         Copies: {copies}
//                       </Typography>
//                     </TableCell>
//                     <TableCell
//                       align="right"
//                       sx={{ whiteSpace: 'nowrap', borderBottom: 'none' }}
//                     >
//                       {formatCurrency(totalPrice)}
//                     </TableCell>
//                     {/* <TableCell align="center" sx={{ borderBottom: 'none' }}>
//                       <PDFIconButton
//                         transaction={txn}
//                         customerName={displayName}
//                       />
//                     </TableCell> */}
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box mt={4}>
//           <Link to="/">
//             <Button variant="contained" color="primary">
//               Go to Store
//             </Button>
//           </Link>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

const PurchaseConfirmationPage = ({
  productName,
  prices,
  to,
  serialNumbers,
  transactions,
  customerName,
}: PurchaseConfirmation) => {
  const fallback = transactions?.[0];

  const displayName =
    customerName ??
    `${fallback?.firstName ?? ''} ${fallback?.lastName ?? ''}`.trim();
  const displayTo = to ?? fallback?.email;

  // Aggregate subtotal and total
  const computedSubtotal = (transactions ?? []).reduce((sum, txn) => {
    return sum + (txn.prices?.subtotal ?? 0);
  }, 0);

  const computedTotal = (transactions ?? []).reduce((sum, txn) => {
    return sum + (txn.prices?.totalPrice ?? 0);
  }, 0);

  const showTotals = (transactions?.length ?? 0) > 1;

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
        <Typography variant="h4" gutterBottom>
          Thank you for your purchase!
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          A confirmation email has been sent to {displayTo}. Please save this
          for your records. If you created an account, your serial numbers and
          invoices are also available to you in your Account Dashboard.
        </Typography>

        <TableContainer sx={{ mt: 4 }}>
          <Table size="small">
            <TableBody>
              {(transactions ?? []).map((txn) => {
                const serials = txn.serials ?? serialNumbers ?? [];
                const copies = txn.prices?.copies ?? prices?.copies;
                const totalPrice = txn.prices?.totalPrice ?? prices?.totalPrice;

                return (
                  <TableRow key={txn._id}>
                    <TableCell sx={{ borderBottom: 'none' }}>
                      <Typography variant="body1" fontWeight="bold">
                        {txn.productName ?? productName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Serials: {formatList(serials)} &nbsp;&bull;&nbsp;
                        Copies: {copies}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ whiteSpace: 'nowrap', borderBottom: 'none' }}
                    >
                      {formatCurrency(totalPrice)}
                    </TableCell>
                    {/* Uncomment if you want invoice download */}
                    {/* <TableCell align="center" sx={{ borderBottom: 'none' }}>
                      <PDFIconButton
                        transaction={txn}
                        customerName={displayName}
                      />
                    </TableCell> */}
                  </TableRow>
                );
              })}
              <br />
              {showTotals && (
                <>
                  <TableRow>
                    <TableCell sx={{}}>
                      <Typography variant="body2" fontWeight="medium">
                        Subtotal
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                      {formatCurrency(computedSubtotal)}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography variant="body1" fontWeight="bold">
                        Total
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                      {formatCurrency(computedTotal)}
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box mt={4}>
          <Link to="/">
            <Button variant="contained" color="primary">
              Go to Store
            </Button>
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default PurchaseConfirmationPage;
